import { BaseResponse } from '../response/baseResponse'

export class Fido2CredentialApi extends BaseResponse {
  credentialId: string
  keyType: string
  keyAlgorithm: string
  keyCurve: string
  keyValue: string
  prfKey: string
  rpId: string
  userHandle: string
  userName: string
  counter: string
  rpName: string
  userDisplayName: string
  discoverable: string
  creationDate: string

  constructor(data: any = null) {
    super(data)
    if (data == null) {
      return
    }

    this.credentialId = this.getResponseProperty('CredentialId')
    this.keyType = this.getResponseProperty('KeyType')
    this.keyAlgorithm = this.getResponseProperty('KeyAlgorithm')
    this.keyCurve = this.getResponseProperty('KeyCurve')
    this.keyValue = this.getResponseProperty('keyValue')
    this.prfKey = this.getResponseProperty('PrfKey')
    this.rpId = this.getResponseProperty('RpId')
    this.userHandle = this.getResponseProperty('UserHandle')
    this.userName = this.getResponseProperty('UserName')
    this.counter = this.getResponseProperty('Counter')
    this.rpName = this.getResponseProperty('RpName')
    this.userDisplayName = this.getResponseProperty('UserDisplayName')
    this.discoverable = this.getResponseProperty('Discoverable')
    this.creationDate = this.getResponseProperty('CreationDate')
  }
}
